export default __webpack_public_path__ + "static/media/Harness of the Blood Drinker (nm).5a1417fe.jpg";